import { useQuery } from '@apollo/client/react';
import { useAuth } from 'react-oidc-context';
import { hasAnyRelevantRole } from '../utils/user';
import type { Theme } from './store/useThemeStore.ts';
import { DOCTOR_THEME_QUERY } from './useDoctorTheme.gql';

export const useDoctorTheme = (doctorId: string): Theme | null | undefined => {
  const auth = useAuth();
  const hasAnyRole = hasAnyRelevantRole(auth.user);

  const { data, previousData } = useQuery(DOCTOR_THEME_QUERY, {
    variables: {
      doctorId: doctorId,
    },
    fetchPolicy: 'cache-and-network',
    skip: !doctorId || !hasAnyRole,
  });

  if (data) {
    // we actually have the current data
    return data.doctor?.theme;
  }

  // when we don't have the current data (e.g. loading state) return the prev data if there is one
  return previousData?.doctor?.theme;
};
